import React from 'react';
import { SkeletonBrick } from '@carnica/ui-kit';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const AccumulatorsSkeleton = () => (
  <div className={cn('container')}>
    <div className={cn('wrapper', 'common')}>
      <div className={cn('item')}>
        <SkeletonBrick className={cn('block')} height={60} width="100%" />
      </div>
      <div className={cn('item')}>
        <SkeletonBrick className={cn('block')} height={60} width="100%" />
      </div>
    </div>
    <div className={cn('item')}>
      <SkeletonBrick className={cn('line')} height={32} width="100%" />
    </div>
  </div>
);
